
import React from 'react'

import './styles/Video.scss';
import CloseImg from '../../images/icons/close_white.svg';

import VideoThumb from './VideoThumb'

class Video extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      play: false,
    }
    this.togglePlay = this.togglePlay.bind(this)
  }

  togglePlay(){
    this.setState({
      play: !this.state.play
    })
    console.log(this.state.play);
  }
/*
  shouldComponentUpdate(nextProps, nextState){
    return (this.props.video.code !== nextProps.video.code || nextState.play !== this.state.play);
  }
*/
  render(){
    let { play } = this.state;
    return <div className={this.props.class } style={{height: this.props.height? this.props.height : 'auto'}}>
        <VideoThumb showDescription={false} showName={false} click={this.togglePlay}
          {...this.props} children={null} play={play} />

          { this.props.children }
          { play &&  <div style={{
            position: 'absolute',
            zIndex: 10,
            background: 'rgba(0,0,0,0.8)',
            top:0,left:0, right:0, bottom:0
          }}>
          <iframe allowFullScreen="allowfullscreen" style={{
            position: 'absolute'
          }} width="100%" height={this.props.height? this.props.height : '100%'}
            className="youtube-frame"
            src={`https://www.youtube.com/embed/${this.props.video.code}?autoplay=0`} />
          <img alt="Play/Pause"
            onClick={this.togglePlay}
            src={CloseImg}
            style={{zIndex:10, position: 'absolute', bottom:'56px', right:'16px', background:'rgba(0,0,0,0.2)', borderRadius:'50%'}} />
          </div> }
      </div>
  }

}

Video.defaultProps = {
  height: 0
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/video/Video.jsx